<ng-container *ngIf="_isDialog; else childComponent">
    <cmps-dialog>
        <cmps-dialog-header>
            <div class="cmps-mi2-trend-dialog--header">
                {{
                    (_data?.mode === _TrendDialogMode.IMPROVEMENT
                        ? _i18n._9871_IMPROVEMENT_HISTORY
                        : _i18n._9872_SCORECARD_HISTORY
                    ) | translate
                }}
            </div>
        </cmps-dialog-header>
        <cmps-dialog-body>
            <ng-chart-chart
                class="cmps-mi2-trend-dialog--chart"
                [options]="_chartOptions"
                [data]="_chartData"
                (pointMouseOver)="_onPointMouseOver($event)"
                (pointMouseOut)="_onPointMouseOut()"
                *ngIf="_chartData"
            ></ng-chart-chart>
            <div
                class="py-3 text-center w-100"
                *ngIf="!_chartData"
            >
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
        </cmps-dialog-body>
    </cmps-dialog>
</ng-container>

<ng-template #childComponent>
    <ng-chart-chart
        class="cmps-mi2-trend-component--chart"
        [options]="_chartOptions"
        [data]="_chartData"
        (pointMouseOver)="_onPointMouseOver($event)"
        (pointMouseOut)="_onPointMouseOut()"
        *ngIf="_chartData"
    ></ng-chart-chart>
    <div
        class="py-3 text-center w-100"
        *ngIf="!_chartData"
    >
        {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>
</ng-template>

<ng-template
    let-data="data"
    #callout
>
    <div class="cmps-mi2-trend-dialog--callout-handle">
        <div
            class="cmps-mi2-trend-dialog--callout"
            *ngIf="data"
        >
            <ng-container *ngIf="_data?.mode === _TrendDialogMode.IMPROVEMENT">
                <div>{{ _i18n._9853_IMPROVEMENT_CATEGORY | translate }}</div>
                <div
                    class="cmps-mi2-trend-dialog--callout-score"
                    [style.background-color]="data?.d?.color"
                >
                    <span>{{ data?.d?.label }}</span>
                </div>
                <div>
                    {{ _i18n._9873_MI2_PERIOD_ | translate }}
                    {{ data?.d?.x | cmpsDate: 'MMM-d-y' }}
                </div>
            </ng-container>
            <ng-container *ngIf="_data?.mode === _TrendDialogMode.SCORECARD">
                <div>{{ _i18n._9857_SCORECARD_CATEGORY | translate }}</div>
                <div
                    class="cmps-mi2-trend-dialog--callout-score"
                    [style.background-color]="data?.d?.color"
                >
                    <span>{{ data?.d?.label }}</span>
                </div>
                <div>
                    {{ _i18n._9875_SCORECARD_DATE_ | translate }}
                    {{ data?.d?.x | cmpsDate: 'MMM-d-y' }}
                </div>
                <div>
                    {{ _i18n._9877_SCORECARD_SCORE_ | translate }}
                    {{
                        (data?.d?.scorecardPoints | cmpsNumber: '1.2-2') ?? '-'
                    }}
                </div>
                <div>
                    {{ _i18n._804_SUPERGROUP_ | translate }}
                    {{ data?.d?.superGroupName ?? '-' }}
                </div>
            </ng-container>

            <ng-container
                *ngIf="
                    _data?.mode === _TrendDialogMode.INSIGHT_TREND ||
                    _data?.mode === _TrendDialogMode.MI2
                "
            >
                <div>
                    {{ _i18n._11045_PERIOD_DATE | translate }}
                    {{ data?.d?.x | cmpsDate: 'MMM-d-y' }}
                </div>
                <div>{{ data?.d?.name }}</div>
                <div>
                    {{ _i18n._725_ACTUAL | translate }}: {{ data?.d?.actual }}
                </div>
                <div>
                    {{ _i18n._726_TARGET | translate }}: {{ data?.d?.target }}
                </div>
                <div>
                    {{ _i18n._768___TO_TARGET | translate }}:
                    {{ data?.d?.pctToTarget }}
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
